import { AnalyzeLayout } from '@/features/analyze/components/AnalyzeLayout';
import { useTranslation } from 'react-i18next';

export const AnalyzeForbiddenScreen = () => {
  const { t } = useTranslation();

  return (
    <AnalyzeLayout>
      <div className="flex h-2/3 flex-col items-center justify-center">
        <h1 className="mb-3 text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
          {t('アクセス権限がありません')}
        </h1>
        <p className="mb-3 text-base leading-7 text-gray-600">
          {t(
            'アクセスしようとしたページはお客様のご契約では、ご利用いただけません。'
          )}
        </p>
      </div>
    </AnalyzeLayout>
  );
};
